import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

interface LessonApproveJoinApiOptions {
  disciplineId: string | number
  lessonId: number
}

/** `POST /admin-api/disciplines/{discipline}/lessons/{booking}/approve-join` — lets a waiting participant into the
 *  lesson room. The answer carries no state: the caller rereads the list. */
export const useLessonApproveJoinApi = async (options: LessonApproveJoinApiOptions): Promise<boolean> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()

  const url = useAdminRoutes('admin.lessons.api.approve-join', {
    discipline_id: options.disciplineId,
    lesson_id: options.lessonId,
  })

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return false
    }

    await $axios.post<ApiResponse>(url)

    toast.success('Join approved')

    return true
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))

    return false
  }
}
